import { store, authActions } from '_store';

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};
const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
function request(method) {

    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            // console.log(authHeader(url),'get url');
            requestOptions.headers['Content-Type'] = 'application/json';
            //requestOptions.headers['Content-Type'] = 'multipart/form-data; boundary=<calculated when request is sent>';
            requestOptions.body = JSON.stringify(body);
        }
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    var getToken = localStorage.getItem('token');
    const token = getToken;//authToken();
 
    const isLoggedIn = !!token;
    const isApiUrl = url.startsWith(baseUrl);
    // console.log(isLoggedIn,'get logged',token,isApiUrl);
   
    if (isLoggedIn && isApiUrl) {
        return { Authorization: `Bearer ${token}` };
    }else{
        return {};
    }
}

function authToken() {
   
   // return store.getState().auth.user?.token;
   return localStorage.getItem('token');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            if ([401, 403].includes(response.status) && authToken()) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                const logout = () => store.dispatch(authActions.logout());
                logout();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}